import { useEffect, useState } from 'react';
import Shell from '../components/Shell';
import { markConsentShown } from '../behaviour';
import type { Branding, PlatformConsent } from '../types';

interface ConsentPageProps {
  branding: Branding;
  consentText: string | null;
  // The platform clause for the context add-on (null without it).
  platformConsent: PlatformConsent | null;
  busy: boolean;
  error: string | null;
  onAccept: () => void;
}

export default function ConsentPage({ branding, consentText, platformConsent, busy, error, onAccept }: ConsentPageProps) {
  const [checked, setChecked] = useState(false);
  useEffect(markConsentShown, []);

  // Tenants write their consent text with a literal "[empresa]" placeholder
  // (shown as example text in the settings form) — swap it for their real
  // company name so what they see when writing it matches what renders here.
  const brandName = branding.brandName || 'esta empresa';
  const resolvedConsentText = (
    consentText || 'Autorizo la captura de una video-selfie con fines de verificación de identidad.'
  ).replaceAll('[empresa]', brandName);
  const resolvedPlatformText = platformConsent?.text.replaceAll('[empresa]', brandName);

  return (
    <Shell branding={branding}>
      <h1>Verificación de identidad</h1>
      <p className="lead">
        Para continuar, {brandName} necesita confirmar tu identidad mediante una
        breve prueba de vida (video-selfie) y comparación biométrica.
      </p>

      <div className="consent-box">
        <p>{resolvedConsentText}</p>
        {resolvedPlatformText && <p>{resolvedPlatformText}</p>}
      </div>

      <label className="consent-checkbox">
        <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
        <span>He leído y acepto los términos anteriores.</span>
      </label>

      {error && <p className="error-text">{error}</p>}

      <button className="btn-primary" disabled={!checked || busy} onClick={onAccept}>
        {busy ? 'Procesando…' : 'Continuar'}
      </button>
    </Shell>
  );
}
